import { Box, IconButton, Typography } from '@mui/material'
import { FileDownloadIcon } from '../../../../../../../assets/svgs/FileDownloadIcon'
import { GetFileDownloadUrl } from '../../../../../../../utils/fileUtils'

interface Props {
  fileName: string
  fileKey: string
}
export const FileDownloadCard = (props: Props): JSX.Element => {
  const download = async (): Promise<void> => {
    const downloadUrl = GetFileDownloadUrl(props.fileKey)
    if (downloadUrl == null) return
    window.open(downloadUrl, '_blank', 'noopener,noreferrer')
  }

  return <Box sx={{
    width: 'fit-content',
    minWidth: '344px',
    padding: '13px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    alignItems: 'center',
    border: '1px solid var(--BaseTones-primitive-nuetral-300, rgba(144, 141, 145, 1))',
    borderRadius: 'var(--radi-6, 16px)'
  }}
  >
    <Typography variant='body1'>{props.fileName}</Typography>
    <IconButton
      sx={{ color: 'var(--Theme-primitive-primary-700, rgba(0, 73, 117, 1))' }}
      onClick={download}
    >
      <FileDownloadIcon />
    </IconButton>
  </Box>
}
